import ComponentModule from "@eisinc/Overrides/Components/PurchasedProductCard";

export * from "@eisinc/Overrides/Components/PurchasedProductCard";

export default ComponentModule;
